(function ($) {
  'use strict';

  this.WlcLazyload = function (el, config) {
    this.Version = '1.0.0';

    if (typeof LazyLoad !== 'function') {
      console.log('LazyLoad not found');
      return;
    }

    // Default config
    this.config = {
      registerReload: true,
      registerHandle: true,
      registerReveal: true,
      threshold: 500,
      lazyLoadConfig: {
        data_src: 'src',
        data_srcset: 'srcset',
        // Set image holders lazy load status
        callback_set: this.set,
        callback_error: this.error,
        callback_load: this.load,
      },
    };

    // Merge with supplied arguments if any
    if (arguments[1] && typeof arguments[1] === 'object') {
      if (
        arguments[1].lazyLoadConfig &&
        typeof arguments[1].lazyLoadConfig === 'object'
      ) {
        this.config.lazyLoadConfig = $.extend(
          this.config.lazyLoadConfig,
          arguments[1].lazyLoadConfig
        );
      }
      delete arguments[1].lazyLoadConfig;
      this.config = $.extend(this.config, arguments[1]);
    }

    this.lazyload = new LazyLoad(this.config.lazyLoadConfig);

    if (!this.lazyload) {
      return;
    }

    if (this.config.registerReload) {
      $(el).on('LazyLoad:reload', this.reload.bind(this));
    }
    if (this.config.registerHandle) {
      $(el).on('LazyLoad:handle', this.handle.bind(this));
    }
    if (this.config.registerReveal) {
      $(el).on('LazyLoad:reveal', this.reveal.bind(this));
    }
  };

  this.WlcLazyload.prototype.set = function (el) {
    var node = el.parentNode;

    // If the parent node is not an image wrapper, do not continue
    if (
      !node.classList.contains('image-holder') ||
      node.classList.contains('loading')
    ) {
      return;
    }

    node.className = node.className.concat(' loading');
  };

  this.WlcLazyload.prototype.error = function (el) {
    var node = el.parentNode;

    if (!node.classList.contains('image-holder')) {
      return;
    }

    var elClass = ' ' + node.className;

    node.className = node.className.concat(' lazy-error');

    while (elClass.indexOf(' loading') !== -1) {
      elClass = elClass.replace(' loading', '');
    }

    node.className = elClass.trim();
  };

  this.WlcLazyload.prototype.load = function (el) {
    var node = el.parentNode;

    if (!node.classList.contains('image-holder')) {
      return;
    }

    var elClass = ' ' + node.className;

    while (elClass.indexOf(' loading') !== -1) {
      elClass = elClass.replace(' loading', '');
    }
    node.className = elClass.trim();
  };

  this.WlcLazyload.prototype.reload = function (e) {
    e.stopPropagation();
    this.lazyload.update();
  };

  this.WlcLazyload.prototype.handle = function (e) {
    e.stopPropagation();
    this.lazyload.handleScroll();
  };

  this.WlcLazyload.prototype.reveal = function (e, el) {
    e.stopPropagation();
    this.lazyload._reveal(el);
  };
}).bind(window)(jQuery);
